import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import VueGtag from 'vue-gtag'

import './filters'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: 'G-J1MPLMSZ8Y',
    params: {
      send_page_view: true
    }
  },
  appName: 'GoGoGiving',
  pageTrackerScreenviewEnabled: true
}, router)

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  refreshOnceOnNavigation: true
})

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

Vue.use(VueI18n)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
